import React from 'react';
import Form from './form';
import Closed from './closed';
import Success from './success';

const CreateQuestion = (props) => {
  if (props.QuestionData.Success) return <Success {...props} />;

  if (
    props.QuestionData.Form.ClosedMessage &&
    !props.QuestionData.Form.ServiceIsOpen
  )
    return <Closed {...props} />;

  return <Form {...props} />;
};

export default CreateQuestion;
